import { HttpContextToken, HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, throwError } from "rxjs";
import { AlertService } from "../services/alert.service";

/**
 * Opt a request out of the global snackbar and body-unwrapping, so the caller
 * receives the raw HttpErrorResponse and owns its own messaging. Used by the
 * voucher cards, which need the status code to tell "pool drained" from
 * "server hiccup" and render different states for each.
 */
export const SKIP_ERROR_HANDLING = new HttpContextToken<boolean>(() => false);

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
    const router = inject(Router);
    const alertService = inject(AlertService);

    return next(req).pipe(
        catchError((error) => {
            console.error("Error:", error);

            if (req.context.get(SKIP_ERROR_HANDLING)) {
                return throwError(() => error);
            }

            let errorMessage = "Something went wrong";

            if (error instanceof HttpErrorResponse) {
                if (error.status === 401) {
                    errorMessage = "Unauthorized access.";
                    void router.navigateByUrl("/error", { skipLocationChange: true });
                } else if (error.status === 500) {
                    errorMessage = error.error?.message || "Something went wrong";
                } else {
                    const firstError = error.error?.errors?.[0]?.error;
                    errorMessage =
                        firstError ||
                        error.error?.message ||
                        error.error?.title ||
                        error.error ||
                        error.message ||
                        errorMessage;
                }

                alertService.openSnackBar(errorMessage);
                return throwError(() => error.error);
            }

            alertService.openSnackBar(error.message || errorMessage);
            return throwError(() => error.message);
        }),
    );
};
